import React from 'react';

const DaysCounter = ({ days }) => {
  return (
    <div className="counter">
      <h2>{days} Jours</h2>
    </div>
  );
};

export default DaysCounter;
